import './gradesDropdown.css';

import { Component } from 'react';
import JobEditGrades from '../../JobEdit/jobeditgrades';
import PropTypes from 'prop-types';
import { ATSDistrictJobsListFiltersDataTestIds } from 'data-testids/ATS';

export default class GradesDropdown extends Component {
  static propTypes = {
    grades: PropTypes.arrayOf(PropTypes.number),
    updateMultiSelect: PropTypes.func,
    awaitingRefresh: PropTypes.bool,
    refresh: PropTypes.func,
  };

  state = {
    showingGrades: false,
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside, { capture: true });
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.node && this.node.contains(event.target)) {
      // Inside click
      return;
    }

    this.setState({
      showingGrades: false,
    });

    // If click outside the dropdown and awaiting a debounced search call,
    // prompt an immediate search (not debounced)
    if (this.props.awaitingRefresh) {
      this.props.refresh();
    }
  };

  render() {
    return (
      <div ref={(node) => (this.node = node)} className="dropdown" id="valueItemDrop">
        <button
          className="selectbox"
          id="dLabel"
          data-testid={ATSDistrictJobsListFiltersDataTestIds.GRADE_LEVEL_FILTER}
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          onClick={() => {
            this.setState((prevState) => ({
              showingGrades: !prevState.showingGrades,
            }));
          }}
        >
          Grades
        </button>
        {this.state.showingGrades && (
          <ul className="dropdown-menu-grades" aria-labelledby="dLabel">
            <JobEditGrades
              grades={this.props.grades}
              onChange={(values) => this.props.updateMultiSelect(values, 'grades')}
            />
          </ul>
        )}
      </div>
    );
  }
}
